<template>
    <div
        v-if="system"
        class="absolute top-0 sm:left-1/2 sm:-translate-x-1/2 w-full sm:w-1/2 bg-rose-500 text-black z-50 sm:p-1 shadow rounded rounded-t-none transform transition-transform flex text-xs font-bold justify-center">
        Entwicklungssystem: {{ system }}
    </div>
</template>

<script setup>
const system = computed(() => useRuntimeConfig().public.systemBanner.system)
</script>